<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="modal-body" style="text-align:center">
      <p>{{ $t('shopCommunityManage.confirmDeleteShopCommunity') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="deleteShopCommunity">
        {{ $t('common.confirmDelete') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteShopCommunity } from '@/api/goods/shopCommunityApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteShopCommunity',
  data() {
    return {
      dialogVisible: false,
      deleteShopCommunityInfo: {}
    }
  },
  methods: {
    open(data) {
      this.dialogVisible = true
      this.deleteShopCommunityInfo = { ...data }
    },
    handleClose() {
      this.deleteShopCommunityInfo = {}
    },
    async deleteShopCommunity() {
      try {
        await deleteShopCommunity({
          ...this.deleteShopCommunityInfo,
          shopId: getShopId()
        })
        this.$message.success(this.$t('common.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error(error)
      }
    }
  }
}
</script>